import React, { useState, useRef, useEffect } from "react";
import { useOutsideAlerter } from "../../../helpers";
import {
  twitterScript,
  fbScript,
  linkedInScript,
  weiboScript
} from "./scripts";
import "./index.scss";

export interface ShareBtnProps {
  isDark?: Boolean;
  socialMedia: {
    showFacebook?: Boolean;
    showTwitter?: Boolean;
    showEmail?: Boolean;
    showLinkedIn?: Boolean;
    showWeibo?: Boolean;
    showWhatsApp?: Boolean;
  } | null;
  disable?: Boolean;
  isRightAligned?: Boolean;
}

const ShareButton = (props: ShareBtnProps) => {
  let [share, updateShare] = useState(false);

  const {
    socialMedia = {
      showFacebook: false,
      showTwitter: false,
      showEmail: false,
      showLinkedIn: false,
      showWeibo: false,
      showWhatsApp: false
    },
    disable
  } = props;

  const showFacebook = socialMedia ? socialMedia.showFacebook : false;
  const showTwitter = socialMedia ? socialMedia.showTwitter : false;
  const showEmail = socialMedia ? socialMedia.showEmail : false;
  const showLinkedIn = socialMedia ? socialMedia.showLinkedIn : false;
  const showWeibo = socialMedia ? socialMedia.showWeibo : false;
  const showWhatsApp = socialMedia ? socialMedia.showWhatsApp : false;

  const ref = useRef(null);
  const condition = share === true;
  const link = encodeURIComponent(location.href);
  const TwitterShareLink = `?url=${link}&text=${document.title}`;
  const EmailShareLink = `mailto:info@example.com?&subject=${link}&body=${link} ${document.title}`;

  useOutsideAlerter({
    ref,
    condition,
    callback: () => {
      updateShare(!condition);
    }
  });

  const Twitter = () => {
    useEffect(() => {
      twitterScript();
    });

    return (
      <li className="twitter">
        <div>
          <a
            className="twitter-share-button"
            href={`https://twitter.com/intent/tweet${TwitterShareLink}`}
            title="Twitter"
          >
            Tweet
          </a>
        </div>
      </li>
    );
  };

  const Facebook = () => {
    useEffect(() => {
      fbScript();
    }, []);

    return <li className="facebook" title="Facebook" />;
  };

  const LinkedIn = () => {
    useEffect(() => {
      linkedInScript();
    });

    return <li className="linkedIn" title="Linkedin" />;
  };

  const Weibo = () => {
    useEffect(() => {
      weiboScript();
    });

    return <li className="weibo" title="Weibo" />;
  };

  const WhatsApp = () => (
    <li className="whatsapp">
      <a
        href={`whatsapp://send?text=${encodeURI(
          "Take a look at this website: " + location.href
        )}`}
        className="wa_btn wa_btn_l"
        title="Whatsapp"
      >
        Share
      </a>
    </li>
  );

  const Btn = (props: ShareBtnProps) => (
    <div
      ref={ref}
      className={`btn__share-wrap${
        props.isDark ? " btn__share-wrap--dark" : ""
      }${props.isRightAligned ? " btn__share-wrap--right" : ""}`}
    >
      <div className={`btn__share-pane`}>
        <div className={`btn__share-caption`}>Share:</div>
        <ul>
          {showFacebook ? <Facebook /> : null}
          {showTwitter ? <Twitter /> : null}
          {showLinkedIn ? <LinkedIn /> : null}
          {showWeibo ? <Weibo /> : null}
          {showWhatsApp ? <WhatsApp /> : null}
          {showEmail ? (
            <li className="email">
              <a href={EmailShareLink} title="Mail">
                Mail
              </a>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );

  const checkSocial = (socialMedia: any) => {
    return Object.keys(socialMedia).some(channel => socialMedia[channel]);
  };

  return !disable &&
    checkSocial({
      showFacebook,
      showTwitter,
      showEmail,
      showLinkedIn,
      showWeibo,
      showWhatsApp
    }) ? (
    <Btn {...props} />
  ) : null;
};

export default ShareButton;
